"use client";

import useDetectScroll from "@smakss/react-scroll-direction";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import StyledContainer from "@/components/StyledContainer";
import clsx from "clsx";
import { CgMenuLeft } from "react-icons/cg";
import TopBar from "@/components/StyledHeader/TopBar";
import MainNavigation from "@/components/StyledHeader/MainNavigation";

const getHomeUrl = (lang = "en-us") => {
  if (lang === "es-es") return "/es";
  if (lang === "ru-ru") return "/ru";
  return "/";
};

const NavContainer = ({
  settings,
  navigation,
  overlayMenu = false,
  currentPageUid,
  otherLanguages,
  lang,
}) => {
  const { scrollDir, scrollPosition } = useDetectScroll();
  const pathname = usePathname();
  const logoHref = pathname.startsWith("/es") ? "/es" : "/";

  const [stickyMenu, setStickyMenu] = useState(false);

  useEffect(() => {
    if (scrollPosition?.top <= 0) {
      setStickyMenu(false);
    } else {
      setStickyMenu(scrollDir === "up");
    }
  }, [scrollDir, scrollPosition]);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div
      className={clsx({
        "z-50 transition-all left-0 w-full": true,
        absolute: !stickyMenu && overlayMenu,
        relative: !stickyMenu && !overlayMenu && scrollPosition.top < 100,
        "fixed top-[-150px]": scrollPosition.top > 140 && !stickyMenu,
        "fixed top-0": stickyMenu,
      })}
    >
      <div
        className={clsx({
          "w-full min-w-full bg-[#1F2223] p-0": true,
          "bg-opacity-[40%]": overlayMenu && !stickyMenu,
        })}
      >
        <TopBar
          scrollPosition={scrollPosition}
          settings={settings}
          stickyMenu={stickyMenu}
          otherLanguages={otherLanguages}
        />
        <StyledContainer
          className={clsx({
            relative: true,
            "z-[12]": mobileMenuOpen,
            "z-0": !mobileMenuOpen,
          })}
        >
          <div
            className={clsx({
              "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 rounded-[10px]": true,
              "h-[58px]": stickyMenu,
              "h-[58px] lg:h-[78px] xl:h-[88px] transition-all": !stickyMenu,
            })}
          >
            <PrismicNextLink
              href={getHomeUrl(lang)}
              className="text-xl font-semibold tracking-tight"
              aria-label="Logo"
            >
              <PrismicNextImage
                field={settings?.data.site_logo}
                fallbackAlt={""}
                width={249}
                height={99}
                priority
                loading="eager"
              />
            </PrismicNextLink>
            <button
              className={`xl:hidden flex items-center`}
              aria-label="Open mobile menu"
            >
              <CgMenuLeft
                size={24}
                className="text-2xl text-white cursor-pointer ms-4"
                onClick={toggleMenu}
              />
            </button>

            <MainNavigation
              mobileMenuOpen={mobileMenuOpen}
              settings={settings}
              navigation={navigation}
              closeMobileMenu={closeMobileMenu}
              currentPageUid={currentPageUid}
            />
          </div>
        </StyledContainer>
      </div>
    </div>
  );
};

export default NavContainer;
